export default ngModule => {
    ngModule.filter('nocents', ['$filter', '$locale', function ($filter, $locale) {
        var currency = $filter('currency'), formats = $locale.NUMBER_FORMATS;
        return function (amount, symbol) {
            var value = currency(amount, symbol);
            return value.replace(
                new RegExp('\\' + formats.DECIMAL_SEP + '\\d{2}'), '');
        }
    }]);
};


// WEBPACK FOOTER //
// ./src/filters/currency.js